import { API_BASE_URL } from "../config";

export async function registerUser(payload) {
    const response = await fetch(`${API_BASE_URL}/customer-management/registration/patient`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || "Registration failed");
    }

    return data;
}


/* ─── API helpers ────────────────────────────────────────────────── */
export async function apiQuickRegister(payload) {
  const res = await fetch(`${API_BASE_URL}/patientreg/quick-register`, {
    method: "POST",
    headers: { "Content-Type": "application/json", accept: "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.detail || "Registration failed");
  return data;
}

export async function apiRegister(payload) {
  const res = await fetch(`${API_BASE_URL}/patientreg/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json", accept: "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.detail || "Registration failed");
  return data;
}

export async function apiSendOtp(mobileNumber) {
  const res = await fetch(`${API_BASE_URL}/patientreg/send-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json", accept: "application/json" },
    body: JSON.stringify({ mobileNumber }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.detail || "Failed to send OTP");
  return data;
}

export async function apiRegVerifyOtp(mobileNumber, otp) {
  const res = await fetch(`${API_BASE_URL}/patientreg/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json", accept: "application/json" },
    body: JSON.stringify({ mobileNumber, otp }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.detail || "Invalid OTP");
  return data;
}
export async function apiSetPassword(
  payload
) {
  const res = await fetch(`${API_BASE_URL}/patientreg/password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(
      data.message || data.detail || "Failed to set password"
    );
  }

  return data;
}



// ─────────────────────────────────────────
// API helpers for SignIn component (can be moved to a separate file if needed)
// ─────────────────────────────────────────

export async function apiLoginByOtp(body) {
  const res = await fetch(`${API_BASE_URL}/patientreg/login/otp/send`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message ?? "OTP send failed. Please try again.");
  return data;
}

export async function apiVerifyOtp(mobileNumber, otp) {
  const res = await fetch(`${API_BASE_URL}/patientreg/login/otp/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json", accept: "application/json" },
    body: JSON.stringify({ mobileNumber, otp, orgName: "FemCare" }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.detail || "Invalid OTP");
  return data;
}

export async function apiLoginByPassword(body) {
  const res = await fetch(`${API_BASE_URL}/patientreg/login/password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message ?? "Login failed. Please try again.");
  return data;
}

export async function apiResendOtp(mobile) {
  const res = await fetch(`${API_BASE_URL}/patientreg/login/otp/send`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mobileNumber: mobile, orgName: "FemCare" }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message ?? "Failed to send OTP. Please try again.");
  return data;
}